import React, { useState, useEffect, useRef } from "react";
import { MDBAlert, MDBCard, MDBCardBody, MDBCardHeader, MDBCardFooter } from "mdb-react-ui-kit";
import Webcam from "react-webcam";
import jsQR from "jsqr";
import { getMemberTransactions, getBusinessName, getPricingPlansById, validateMultiGymCheckin, getBookedsessionsbymid } from "../src/services/apiServices";
import { useNavigate, useLocation } from 'react-router-dom'; // Assuming you're using react-router for navigation
import GymLogo from "./components/images/Easy-MembrLogo.png";
import PageError from "../src/views/PageError";

const QRScanner = () => {
    const webcamRef = useRef(null);
    const [qrData, setQrData] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [error, setError] = useState("")
    const [businessData, setBusinessData] = useState(null);
    const [checkinMsg, setCheckinMsg] = useState("");
    const [apiError, setApiError] = useState(false);
    let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;
    const [classToggle, setClassToggle] = useState(false)

    useEffect(() => {
        const token = localStorage.getItem("token");
        console.log(token)
        if (!token) {
            navigate("/qrlogin")
        }
        if (plansInfo != null && plansInfo?.feature?.qrcheckin == false) {
            navigate("/qrlogin");
        }
    }, [navigate]);


    useEffect(() => {
        const getPricingPlansBYGymid = async () => {
            const response = await getPricingPlansById(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response) {
                return
            }
            if (response === "false") {
                return
            }
            const recinfo = await response.json();

            if (recinfo && recinfo.feature) {
                localStorage.setItem("planInfo", JSON.stringify(recinfo));
            } else {
                localStorage.removeItem("planInfo");
            }
        }
        if (localStorage.getItem("loggedUserInfo")) {
            getPricingPlansBYGymid();
        } else {
            localStorage.removeItem('planInfo');
        }
    }, [localStorage.getItem("planInfo"), localStorage.getItem("loggedUserInfo")]);

    const videoConstraints = {
        facingMode: { ideal: "environment" },
        width: 350,
        height: 350,

    };

    useEffect(() => {
        if (location.state?.successMessage && location.state?.showSuccess) {
            setCheckinMsg(location.state.successMessage);

            const timer = setTimeout(() => {
                setCheckinMsg("");
                navigate("/qrscanner", { replace: true });
            }, 3000);

            return () => clearTimeout(timer);
        }
        const storedData = localStorage.getItem("checkinmsg");

        if (storedData) {
            setCheckinMsg(storedData);

            const timer = setTimeout(() => {
                setCheckinMsg("");
                localStorage.removeItem("checkinmsg");
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [location.state, navigate]);


    const scanQRCode = () => {
        const video = webcamRef.current?.video;

        if (video && video.readyState === 4) {
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const code = jsQR(imageData.data, imageData.width, imageData.height);

            if (code) {
                setQrData(code.data);
            }
        }
    };

    useEffect(() => {
        let animationFrameId;

        const render = () => {
            scanQRCode();
            animationFrameId = requestAnimationFrame(render);
        };

        render();

        return () => cancelAnimationFrame(animationFrameId);
    }, []);

    const requestCameraPermission = () => {
        navigator.mediaDevices
            .getUserMedia({ video: true })
            .then(() => {
                console.log("Camera access granted");
            })
            .catch((err) => {
                console.error("Camera access denied:", err);
            });
    };

    useEffect(() => {
        if (webcamRef.current) {
            requestCameraPermission();
        }
    }, []);

    useEffect(() => {
        const fetchApiData = async () => {
            if (!qrData) return;

            try {
                setLoading(true);

                let parsedData;
                try {
                    parsedData = JSON.parse(qrData);
                } catch (err) {
                    setError("Invalid QR code");
                    throw new Error("Invalid QR code. Unable to parse as JSON.");
                }

                const mid = parsedData?.mid;
                const homeGymId = parsedData?.bid;
                let gymid = homeGymId;

                let activeClass = null;
                if (classToggle) {
                    const activeSessionsReq = await getBookedsessionsbymid(gymid, { gymid: gymid, memberid: mid, minutes: 30 });
                    const activeSessionsRes = await activeSessionsReq.json();
                    console.log("activeSessionsRes", activeSessionsRes);
                    if (activeSessionsRes.length > 0) {
                        activeClass = activeSessionsRes[0];
                    } else {
                        setError("This member has not booked any class sessions yet.");
                        return;
                    }
                }
                const currentGymId = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
                if (!mid) {
                    throw new Error("MID is missing in the QR code.");
                }

                if (homeGymId === currentGymId) {
                    // STEP 1: Try existing flow - check if member exists in current gym
                    console.log("Step 1: Checking member in current gym...");
                    let response = await getMemberTransactions(mid);

                    if (response && response.ok) {
                        const data = await response.json();

                        if (data && Array.isArray(data) && data.length > 0) {
                            // Member found in current gym - use existing flow
                            console.log("Member found in current gym - proceeding with existing flow");
                            navigate("/qrcheckin", {
                                state: { data, currentGymId, isMultiGym: false, activeClass }
                            });
                            return;
                        }
                    }
                    // Member not found in current gym
                    setError("Member not found in this gym.");
                    return;
                }

                if (homeGymId !== currentGymId) {
                    // STEP 2: Member not in current gym, checking multi-gym eligibility...
                    console.log("Step 2: Member not in current gym, checking multi-gym eligibility...");

                    const updates = {
                        memberId: mid,
                        homeGymId: homeGymId,
                        partnerGymId: currentGymId,
                        currentDate: new Date().toISOString().split("T")[0]
                    };

                    // STEP 3: Validate multi-gym check-in
                    const validationResult = await validateMultiGymCheckin({ updates });

                    // Check if the API call itself failed (network error, etc.)
                    if (!validationResult) {
                        setError("Network error: Unable to validate multi-gym check-in");
                        return;
                    }

                    if (!validationResult.ok) {
                        setError(`API error: ${validationResult.status} ${validationResult.statusText}`);
                        return;
                    }

                    const data = await validationResult.json();
                    console.log("Multi-gym validation response:", data);


                    if (data?.notInCurrentGym === true) {
                        navigate("/qrwaiver", {
                            state: {
                                memberId: data?.memberinfo?._id,
                                homeGymMemberId: mid,
                                memberInfo: data.memberinfo,
                                homeGymId,
                                partnerGymId: currentGymId,
                                activeClass
                            }
                        });
                        return;
                    }


                    if (!data.isValid) {
                        if (data.partnerWaiverRequired === true) {
                            navigate("/qrwaiver", {
                                state: {
                                    memberId: data.partnerGymMemberId || mid,
                                    homeGymMemberId: mid,
                                    memberInfo: data.memberinfo,
                                    homeGymId,
                                    partnerGymId: currentGymId,
                                    activeClass
                                }
                            });
                            return;
                        }

                        setError(data.message || "Multi-gym check-in not allowed");
                        return;
                    }


                    console.log("Step 3: Multi-gym allowed, fetching member data from home gym...");

                    // STEP 4: Get member data from home gym
                    let homeGymResponse = await getMemberTransactions(mid);

                    if (homeGymResponse && homeGymResponse.ok) {
                        const memberData = await homeGymResponse.json();

                        if (memberData && Array.isArray(memberData) && memberData.length > 0) {
                            console.log("Step 4: Multi-gym check-in approved");
                            navigate("/qrcheckin", {
                                state: {
                                    data: memberData,
                                    currentGymId,
                                    isMultiGym: true,
                                    homeGymId: homeGymId,
                                    validationData: data,
                                    activeClass
                                }
                            });
                            return;
                        }
                    }

                    // If we reach here, member not found anywhere
                    setError("Member not found in any eligible gyms");
                }
            } catch (err) {
                console.error("Error:", err.message);
                setError("Error processing QR code: " + err.message);
                setQrData(null);
            } finally {
                setLoading(false);
            }
        };

        fetchApiData();
    }, [qrData, navigate, classToggle]);




    useEffect(() => {
        const fetchData = async () => {
            try {
                const datar = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                if (datar) {
                    const updates = { bId: datar };
                    console.log("Request payload:", updates);

                    const result = await getBusinessName(updates);
                    if (!result) {
                        return;
                    }
                    if (result === "false") {
                        setApiError(true)
                    }
                    console.log("API result:", result);

                    if (result && result.json) {
                        const jsonData = await result.json();
                        setBusinessData(jsonData);
                        console.log("Business data set:", jsonData);
                    } else {
                        console.error("API returned no data or null.");
                    }
                } else {
                    console.warn("datar is undefined or null. Skipping API call.");
                }
            } catch (error) {
                console.error("Error fetching business name:", error);
            }
        };

        fetchData();
    }, []);



    useEffect(() => {
        if (error && !loading) {
            const timer = setTimeout(() => {
                setError("");
            }, 5000);

            return () => clearTimeout(timer);
        }
    }, [error, loading]);



    const handleReload = () => {
        window.location.reload();
    }


    return (

        <div className="h-100vhWave p-0 h-100">
            <div className="qrlayout h-100">
                {apiError ? <PageError handleReload={handleReload} /> :
                    <div className="row justify-content-center">
                        <MDBCard className="col-12 col-md-5">
                            <MDBCardHeader>

                                <div className="mobile-Head mb-2">
                                    <div className="d-flex align-items-center justify-content-between Waiver-logo">
                                        <img src={GymLogo} className="w-30 mob-w-40" alt="Business Logo" />
                                        <div>

                                        </div>
                                        {businessData?.logourl && <img
                                            src={businessData?.logourl || ""}
                                            alt={GymLogo}
                                            className="w-20 mob-w-40"
                                        />}

                                    </div>
                                </div>
                            </MDBCardHeader>
                            <MDBCardBody className=" position-relative" style={{ minHeight: "calc(100vh - 170px)" }}>

                                <div className="mb-4">
                                    {checkinMsg && (
                                        <div className="alert alert-success text-center" role="alert">
                                            {checkinMsg}
                                        </div>
                                    )}

                                </div>
                                <div className="text-center mb-4">
                                    <label className="fw-bold mb-2">Select Check-In Type</label>
                                    <select
                                        className="form-select w-50 mx-auto"
                                        value={classToggle ? "class" : "membership"}
                                        onChange={(e) => setClassToggle(e.target.value === "class")}
                                    >
                                        <option value="membership">Membership Check-In</option>
                                        <option value="class">Class Check-In</option>
                                    </select>
                                    <p className="text-muted fs-11 mt-1">
                                        {classToggle ? "Class Check-In Mode Enabled" : "Membership Check-In Mode Enabled"}
                                    </p>
                                </div>

                                <h4 className="mb-4 text-center">Scan Check-In QR Code</h4>

                                <div className="qr-webcamContainer position-relative">
                                    <div className="qrDiv">
                                        <Webcam
                                            ref={webcamRef}
                                            videoConstraints={videoConstraints}
                                            className="qr-webcam"
                                        />
                                        <div className="scanner-overlay">
                                            <div className="corner top-left"></div>
                                            <div className="corner top-right"></div>
                                            <div className="corner bottom-left"></div>
                                            <div className="corner bottom-right"></div>
                                        </div>
                                    </div>
                                    <div class="scan-square">
                                        <div class="scan">
                                        </div>
                                        <span className="scan-line line-1"></span>
                                        <span className="scan-line line-2"></span>
                                        <span className="scan-line line-3"></span>
                                        <span className="scan-line line-4"></span>
                                        <span className="scan-line line-5"></span>
                                        <span className="scan-line line-6"></span>
                                        <span className="scan-line line-7"></span>
                                        <span className="scan-line line-8"></span>
                                    </div>

                                </div>

                                {loading && (
                                    <div className="text-center mt-3">
                                        <p>Loading...</p>
                                    </div>
                                )}


                                {error && !loading && (
                                    <MDBAlert
                                        color="danger"
                                        autohide
                                        position="top-center"
                                        delay={5000}
                                        appendToBody
                                        open={error !== ""}
                                        onClose={() => setError("")}
                                    >
                                        {error}
                                    </MDBAlert>
                                )}



                            </MDBCardBody>
                            <MDBCardFooter className=" text-center">
                                <p class="mt-2 text-muted"> © 2025 Zencruz.</p>
                            </MDBCardFooter>
                        </MDBCard>
                    </div>
                }
            </div>
        </div>
    );
};

export default QRScanner;
